"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTableHelpers = exports.IctCoreJsApp = exports.NotifyTypes = void 0;
var mdbootbox_1 = require("../UI/mdbootbox");
var snackbar_1 = require("../UI/snackbar");
var NotifyTypes;
(function (NotifyTypes) {
    NotifyTypes[NotifyTypes["Dialog"] = 0] = "Dialog";
    NotifyTypes[NotifyTypes["Console"] = 1] = "Console";
    NotifyTypes[NotifyTypes["Snackbar"] = 2] = "Snackbar";
})(NotifyTypes = exports.NotifyTypes || (exports.NotifyTypes = {}));
var IctCoreJsApp = (function () {
    function IctCoreJsApp() {
        this.mdbootbox = new mdbootbox_1.MDBootboxImplementation();
        this.snackbar = new snackbar_1.Snackbar();
    }
    IctCoreJsApp.prototype.post = function (url, data, successCallback, failCallback, doNotReloadOnUnauthorized, resetPagingOnConfirmation, notifyTypes) {
        var csrfToken = this.getAntiForgeryCookie();
        var ajaxSettings = {
            url: url,
            data: data,
            contentType: 'application/json',
            type: 'POST',
            headers: {
                'X-CSRF-TOKEN': csrfToken
            }
        };
        return this.ajax(ajaxSettings, __spreadArray(__spreadArray([], (notifyTypes !== null && notifyTypes !== void 0 ? notifyTypes : [NotifyTypes.Dialog]), true), [NotifyTypes.Console], false), successCallback, failCallback, doNotReloadOnUnauthorized, resetPagingOnConfirmation);
    };
    IctCoreJsApp.prototype.get = function (url, successCallback, failCallback, doNotReloadOnUnauthorized, notifyTypes) {
        var ajaxSettings = {
            url: url,
            type: 'GET'
        };
        return this.ajax(ajaxSettings, __spreadArray(__spreadArray([], (notifyTypes !== null && notifyTypes !== void 0 ? notifyTypes : [NotifyTypes.Snackbar]), true), [NotifyTypes.Console], false), successCallback, failCallback, doNotReloadOnUnauthorized);
    };
    IctCoreJsApp.prototype.getAntiForgeryCookie = function () {
        return this.getCookie('CSRF-TOKEN');
    };
    IctCoreJsApp.prototype.getLanguageFromDocument = function () {
        return document.documentElement.lang;
    };
    IctCoreJsApp.prototype.ajax = function (settings, notifyTypes, successCallback, failCallback, doNotReloadOnUnauthorized, resetPagingOnConfirmation) {
        var _this = this;
        if (resetPagingOnConfirmation === void 0) { resetPagingOnConfirmation = true; }
        var result = $.Deferred();
        var url = settings != null ? settings.url : '';
        $.ajax(settings).done(function (data, textStatus, jqXHR) {
            if (successCallback != null) {
                if (data && typeof data === 'object' && !Array.isArray(data)) {
                    data.resetPagingOnConfirmation = resetPagingOnConfirmation !== null && resetPagingOnConfirmation !== void 0 ? resetPagingOnConfirmation : true;
                }
                successCallback(data, textStatus, jqXHR);
            }
            else if (data === null || data === void 0 ? void 0 : data.message) {
                _this.notify(data.message, notifyTypes, false);
            }
            result.resolve().catch(function (error) {
                console.error(error);
            });
        }).fail(function (jqXHR, textStatus, errorThrown) {
            var _a;
            if (doNotReloadOnUnauthorized !== true && jqXHR.status === 401) {
                window.location.reload();
            }
            else {
                if (failCallback != null) {
                    failCallback(jqXHR, textStatus, errorThrown);
                }
                else {
                    var message = "Request to '".concat(url, "' failed.");
                    if (((_a = jqXHR === null || jqXHR === void 0 ? void 0 : jqXHR.responseJSON) === null || _a === void 0 ? void 0 : _a.message) != null) {
                        message = jqXHR.responseJSON.message;
                    }
                    if (message !== undefined && message != '') {
                        _this.notify(message, notifyTypes, true);
                    }
                }
            }
            result.reject().catch(function (error) {
                console.error(error);
            });
        }).catch(function (error) {
            console.error(error);
        });
        return result.promise();
    };
    IctCoreJsApp.prototype.getCookie = function (cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var _i = 0, ca_1 = ca; _i < ca_1.length; _i++) {
            var c = ca_1[_i];
            var cTrim = c.trim();
            if (cTrim.startsWith(name)) {
                return cTrim.substring(name.length);
            }
        }
        return '';
    };
    IctCoreJsApp.prototype.notify = function (message, notifyTypes, error) {
        var _this = this;
        notifyTypes
            .filter(function (type, index) { return notifyTypes.indexOf(type) === index; })
            .forEach(function (notifyType) {
            switch (notifyType) {
                case NotifyTypes.Dialog:
                    _this.mdbootbox.alert(message);
                    break;
                case NotifyTypes.Snackbar:
                    _this.snackbar.show({
                        message: message
                    });
                    break;
                case NotifyTypes.Console:
                default:
                    if (error) {
                        console.error(message);
                    }
                    else {
                        console.log(message);
                    }
                    break;
            }
        });
    };
    return IctCoreJsApp;
}());
exports.IctCoreJsApp = IctCoreJsApp;
exports.$app = new IctCoreJsApp();
exports.DataTableHelpers = {
    defaultDrawCallback: function ($dataTableElement, callback) {
        var confirmationDialogOptions = {
            confirmationCallback: function (data) {
                $dataTableElement.DataTable().ajax.reload(undefined, data.resetPagingOnConfirmation);
                if (data === null || data === void 0 ? void 0 : data.message) {
                    exports.$app.snackbar.show({
                        message: data.message
                    });
                }
            }
        };
        $dataTableElement.find('.btn-confirm').each(function (_index, element) {
            var jqueryElement = $(element);
            if (jqueryElement.data('initialized') !== true) {
                jqueryElement.confirmDialog(confirmationDialogOptions);
                jqueryElement.data('initialized', true);
            }
        });
        $dataTableElement.find('[title]').each(function (_index, element) {
            var jqueryElement = $(element);
            if (jqueryElement.data('initialized') !== true) {
                var tooltipOptions = {
                    placement: 'auto',
                    trigger: 'click hover'
                };
                if (jqueryElement.data('tooltip-placement')) {
                    tooltipOptions.placement = jqueryElement.data('tooltip-placement');
                }
                if (jqueryElement.data('trigger')) {
                    tooltipOptions.trigger = jqueryElement.data('trigger');
                }
                jqueryElement.tooltip(tooltipOptions);
                jqueryElement.data('initialized', true);
            }
        });
        $dataTableElement.find('[post-and-refresh-table]').each(function (_index, element) {
            var _a;
            var jqueryElement = $(element);
            if (jqueryElement.data('click-intercepted') === true || element.classList.contains('btn-confirm')) {
                return;
            }
            var url = (_a = element.attributes.getNamedItem('href')) === null || _a === void 0 ? void 0 : _a.value;
            jqueryElement.on('click', function (event) {
                event.preventDefault();
                if (url) {
                    exports.$app.post(url, {}, function () {
                        $dataTableElement.DataTable().ajax.reload(undefined, false);
                        if (callback) {
                            callback();
                        }
                    });
                }
            });
            jqueryElement.data('click-intercepted', true);
        });
    }
};
$(function () {
    if (window['Snackbar::Message']) {
        var messageData = window['Snackbar::Message'];
        exports.$app.snackbar.show({
            message: messageData.Message
        });
    }
    if (window['Dialog::Message']) {
        var dialogData = window['Dialog::Message'];
        exports.$app.mdbootbox.alert(dialogData.Message);
    }
    $('table[data-auto-initialize="true"]').each(function () {
        var $this = $(this);
        $this.coreDataTableV2({
            drawCallback: function () {
                exports.DataTableHelpers.defaultDrawCallback($this);
            }
        });
    });
    $('.datepicker[data-auto-initialize="true"]').each(function (index, element) {
        var $element = $(element);
        var format = $element.data('format');
        var value = $element.val();
        var isValidDateFormat = function (dateStr, format) {
            var formatRegexMap = {
                'dd-mm-yyyy': /^(\d{2})-(\d{2})-(\d{4})$/,
                'mm/dd/yyyy': /^(\d{2})\/(\d{2})\/(\d{4})$/,
                'yyyy-mm-dd': /^(\d{4})-(\d{2})-(\d{2})$/
            };
            var regex = formatRegexMap[format];
            if (regex) {
                return regex.test(dateStr);
            }
            else {
                console.warn("Unsupported date format: ".concat(format, ". Skipping validation."));
                return true;
            }
        };
        if (value && !isValidDateFormat(value, format)) {
            console.error("Invalid date format for element ".concat($element.attr('id'), ". Expected format: ").concat(format));
        }
        ($element).pickadate({ format: format });
    });
    $('.datepicker[data-auto-initialize="true"][data-timezone-offset]').each(function (index, element) {
        var $element = $(element).pickadate('picker');
        $element.on('open', function () { return configureDatePicker(element); });
        $element.on('render', function () { return configureDatePicker(element); });
    });
    function configureDatePicker(element) {
        var $JQueryElement = $(element);
        var timezoneOffset = $JQueryElement.data('timezone-offset');
        var $pickADateElement = $JQueryElement.pickadate('picker');
        var $datePickerContainer = $pickADateElement.$root;
        var today = getTodayInTimezone(timezoneOffset);
        var todayAsString = today.toDateString();
        $datePickerContainer.find('.picker__day--today').each(function (index, value) {
            if (new Date($(this).data('pick')).toDateString() !== todayAsString) {
                $(this).removeClass('picker__day--highlighted');
                $(this).removeClass('picker__day--today');
                return false;
            }
        });
        $datePickerContainer.find('.picker__day').each(function (index, value) {
            if (new Date($(this).data('pick')).toDateString() === todayAsString) {
                $(this).addClass('picker__day--highlighted');
                $(this).addClass('picker__day--today');
                return false;
            }
        });
        $datePickerContainer.find('.picker__button--today').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $pickADateElement.set('select', [today.getFullYear(), today.getMonth(), today.getDate()]);
            $pickADateElement.close(true);
        });
    }
    ;
    function getTodayInTimezone(timezoneOffset) {
        var today = new Date();
        var utc = today.getTime() + (today.getTimezoneOffset() * 60000);
        return new Date(utc + (3600000 * timezoneOffset));
    }
    ;
});
$(function () {
    $('.fullscreen-link').on('click', function (e) {
        var $fullscreenButton;
        switch (e.target.nodeName.toLowerCase()) {
            case "i":
                $fullscreenButton = $(e.target).parent();
                break;
            case "a":
                $fullscreenButton = $(e.target);
                break;
            default:
                console.error("Failed to detect the fullscreen button.", e);
                return;
        }
        var $fullscreenContainer = $($fullscreenButton.parents($fullscreenButton.data('container-selector'))[0]);
        var $icon = $fullscreenButton.children('i.dt-icon');
        var isWindowed = $fullscreenButton.data('is-windowed');
        var shouldToggleSizeClass = $fullscreenButton.data('should-toggle-size-class');
        $icon.toggleClass($fullscreenButton.data('windowed-icon') + ' ' + $fullscreenButton.data('fullscreen-icon'));
        toggleFullscreen(isWindowed, $fullscreenContainer, $fullscreenButton);
        resizeChart(isWindowed, $fullscreenContainer, shouldToggleSizeClass);
    });
    $('input#telemetry-rangepicker').on('change', function (e) {
        window.dispatchEvent(new Event('resize'));
    });
    function toggleFullscreen(isWindowed, $fullscreenContainer, $fullscreenButton) {
        var currentHighestZIndex = getHighestZIndex();
        $fullscreenContainer.css({ 'z-index': isWindowed ? '' : currentHighestZIndex + 1 });
        $('.daterangepicker').css({ 'z-index': isWindowed ? '' : currentHighestZIndex + 2 });
        $fullscreenContainer.toggleClass('fullscreen', !isWindowed);
        $('body').toggleClass('overflow-hidden currently-fullscreen', !isWindowed);
        $fullscreenButton.data('is-windowed', !isWindowed);
    }
    function resizeChart(isWindowed, $fullscreenContainer, shouldToggleSizeClass) {
        if ($fullscreenContainer.find("svg.highcharts-root").length <= 0) {
            return;
        }
        if (!shouldToggleSizeClass) {
            var $loopElement = $fullscreenContainer.find('.highcharts-container');
            while ($loopElement[0] !== $fullscreenContainer[0]) {
                $loopElement.toggleClass('h-100', !isWindowed);
                $loopElement.toggleClass('w-100', true);
                $loopElement = $loopElement.parent();
            }
        }
        window.dispatchEvent(new Event('resize'));
    }
    function getHighestZIndex() {
        var highestZIndex = 0;
        $('div').each(function () {
            var elementZIndex = parseInt($(this).css("z-index"));
            if (elementZIndex > highestZIndex) {
                highestZIndex = elementZIndex;
            }
        });
        return highestZIndex;
    }
    function setZIndex() {
        var currentHighestZIndex = getHighestZIndex();
        var isWindowed = $("[data-is-windowed]").data("is-windowed");
        toggleZIndex($('.modal-backdrop'), currentHighestZIndex + 1, isWindowed);
        toggleZIndex($('.vakata-context'), currentHighestZIndex + 2, isWindowed);
        toggleZIndex($('.bootbox.modal'), currentHighestZIndex + 2, isWindowed);
        toggleZIndex($('.DTCR_clonedTable'), currentHighestZIndex + 2, isWindowed);
        toggleZIndex($('#exportmodal'), currentHighestZIndex + 2, isWindowed);
        toggleZIndex($('.DTCR_pointer'), currentHighestZIndex + 3, isWindowed);
    }
    function toggleZIndex($element, zIndex, isWindowed) {
        if ($element.length <= 0) {
            return;
        }
        if (!isWindowed) {
            $element.css({ 'z-index': '' });
        }
        else {
            var styleAttribute = $element.attr("style");
            if (styleAttribute == null) {
                styleAttribute = '';
            }
            $element.attr("style", "".concat(styleAttribute, " z-index: ").concat(zIndex, " !important;"));
        }
    }
    var observer = new MutationObserver(function (mutationsList, observer) {
        for (var _i = 0, mutationsList_1 = mutationsList; _i < mutationsList_1.length; _i++) {
            var mutation = mutationsList_1[_i];
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeType === 1) {
                        if (node.classList.contains("vakata-context") ||
                            node.classList.contains("bootbox modal") ||
                            node.classList.contains("modal-backdrop") ||
                            node.classList.contains("DTCR_clonedTable") ||
                            node.classList.contains("DTCR_pointer") ||
                            node.id === "exportmodal") {
                            setupRemoveObserver(node);
                        }
                    }
                });
                mutation.removedNodes.forEach(function (node) {
                    if (node.classList &&
                        (node.classList.contains("vakata-context") ||
                            node.classList.contains("modal-backdrop") ||
                            node.classList.contains("DTCR_clonedTable") ||
                            node.classList.contains("DTCR_pointer") ||
                            node.classList.contains("bootbox modal") ||
                            node.id === "exportmodal")) {
                        setZIndex();
                    }
                });
            }
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    function setupRemoveObserver(node) {
        var removeObserver = new MutationObserver(function (mutationsList) {
            for (var _i = 0, mutationsList_2 = mutationsList; _i < mutationsList_2.length; _i++) {
                var mutation = mutationsList_2[_i];
                if (mutation.type === 'childList') {
                    setZIndex();
                }
            }
            removeObserver.disconnect();
        });
        removeObserver.observe(node, { childList: true });
    }
    $('body').on('submit', function (e) {
        if ($(e.target).data('keep-enabled') == true || (e.target.tagName.toLowerCase() !== "form")) {
            return;
        }
        $(e.target).find('button[type="submit"], input[type="button"]').each(function (index, element) {
            $(element).prop('disabled', $(e.target).find('input.invalid').length <= 0);
            if ($(element).prop('value') !== undefined && $(element).prop('name') !== undefined) {
                $(e.target).append('<input type="hidden" value="' + $(element).prop('value') + '" name="' + $(element).prop('name') + '">');
            }
        });
    });
});
